import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";

import './style.scss';
import categoryCode from './categoryCode';

import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
    FormGroup,
    FormInput,
    FormSelect,
    Button,
    Card,
    CardBody,
    CardHeader,
    Collapse,
    Row,
    Col,
    Badge,
    FormCheckbox, FormTextarea, ModalHeader, ModalBody, Modal
} from "shards-react";
import {Link} from "react-router-dom";
import moment from "moment";


// https://smartsms.aligo.in/alimapi.html
@inject(({ common }) => ({ getDoc: common.getDoc, updateDoc: common.updateDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ booster }) => ({ addKakaoProfile: booster.addKakaoProfile, getBoosterSetting: booster.getBoosterSetting, setBoosterSetting: booster.setBoosterSetting, setKakaoTemp:booster.setKakaoTemp, removeKakaoTemp:booster.removeKakaoTemp, sendTestKakao: booster.sendTestKakao, getAlimReviewHourStats: booster.getAlimReviewHourStats }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData, getAligoProfileList:AOA.getAligoProfileList }))
@inject(({ product }) => ({ getProductList: product.getProductList }))

@observer
class KakaoMsgSetting extends Component {

    // basic
    @observable store = {};
    @observable teamUser = {};
    @observable permissions = {};
    @observable isLogin = false;
    @observable isLoading = false;

    // settings
    @observable authStep = 1;
    @observable regedPlusId = false;
    @observable channelStatus = ''; // 알리고 발신프로필 상태 (A 정상 / S 차단 / D 삭제)
    @observable category = ["", "" ,""];

    @observable firstSendOptions = [
        { value: 0, label: "도착 당일 발송" },
        { value: 1, label: "1일 후 발송" },
        { value: 2, label: "2일 후 발송" },
        { value: 3, label: "3일 후 발송" },
        { value: 5, label: "5일 후 발송" },
    ];
    @observable resendTypeOptions = [
        { value: "total", label: "통합 (작성가능 리스트 1회 발송)" },
        { value: "product", label: "상품(주문상품 마다 알림톡 발송)" }
    ];

    @observable sendIntervalOptions = [
        { value: 1, label: "1일 마다" },
        { value: 2, label: "2일 마다" },
        { value: 3, label: "3일 마다" },
        { value: 4, label: "4일 마다" },
        { value: 5, label: "5일 마다" },
    ];
    @observable sendCountOptions = [
        { value: 1, label: "1회" },
        { value: 2, label: "2회" },
        { value: 3, label: "3회" },
        { value: 4, label: "4회" },
        { value: 5, label: "5회" },
        { value: 0, label: "재발송 안함" },
    ];

    @observable categoryOptions = {
        firstCate : categoryCode.data.firstBusinessType
    };

    @observable boosterSetting = {
        isKakaoPlusidAuth: false,
        kakaoPlusid: "",
        phonenumber: "",
        authnum: "",
        categorycode: "",
        isUse: false,
        firstSend: 2,
        isResend: true,
        resendType: "total",
        sendInterval : 2,
        sendCount : 3,
        sendStartTime: 6,
        sendEndTime: 18,
        temp: {}
    };

    @observable templtContent = "안녕하세요, #{name}님!\n\n#{shop}에서 구매하신 #{product}는 어떠셨나요?\n\n많은 분들께 도움이 될 수 있도록 \n소중한 후기를 공유해주세요";
    @observable isTempEdit = {};

    // 알림톡 경유 작성 리뷰의 시간대(0~23시) 분포 — 발송 시간대 설정 참고용 (null = 미로딩/데이터 없음 → 미표시)
    @observable alimHourStats = null;

    // 리디자인: 섹션 접이식 상태 (발송 설정은 기본 펼침)
    @observable expandedSections = {
        settings: true,
        templates: false,
        channel: true
    };

    // 리디자인: 선택된 템플릿 슬롯 (미리보기 대상)
    @observable selectedTemplateSlot = null;

    // 리디자인: 발송 설정 변경 추적 (dirty + snapshot)
    @observable isSettingsDirty = false;
    settingsSnapshot = null;
    SETTINGS_FIELDS = ['firstSend', 'sendStartTime', 'sendEndTime', 'sendInterval', 'sendCount', 'isSendMsg'];

    // 5단계: 마이크로 인터랙션 — 잔량 펄스, 이탈 확인
    @observable isQuotaPulsing = false;

    // test send
    @observable testSend = {
        phoneNumber: "",
        templtCode: "",
        // 작성자 이름 — 테스트 발송에서 알림톡 인사말/리뷰 작성자로 사용
        writerName: "",
        // 테스트 발송에 포함할 상품 — 선택 시 고객이 실제 상품 정보로 작성까지 체험 가능
        platformProductId: "",
        productName: "",
        productImage: "",
    };

    // 테스트 발송 상품 검색 패널
    @observable productSearch = {
        isOpen: false,
        keyword: "",
        isSearching: false,
        results: [],
        page: 1,
        totalPages: 1,
    };

    //modals
    @observable modals = {
        data: null,
        isTempComment: false,
        isTestSend: false,
        isUseChange: false,
    };

    // 리디자인: "사용 변경" 확인 모달용 타겟
    @observable useChangeTarget = { slot: null, temp: null };

    // 리디자인: 행별 더보기(⋯) 메뉴 열림 상태
    @observable openMoreMenuSlot = null;
    @observable moreMenuPos = null; // {top, left} — portal 좌표

    constructor(props) {
        super(props);
        this.init();
    }

    componentDidMount() {
        // 페이지 이탈 시 미저장 변경사항 확인 (브라우저 기본 confirm)
        this._beforeUnloadHandler = (e) => {
            if (this.isSettingsDirty) {
                e.preventDefault();
                e.returnValue = '저장되지 않은 변경사항이 있습니다. 정말 떠나시겠습니까?';
                return e.returnValue;
            }
        };
        window.addEventListener('beforeunload', this._beforeUnloadHandler);
    }

    componentWillUnmount() {
        if (this._beforeUnloadHandler) {
            window.removeEventListener('beforeunload', this._beforeUnloadHandler);
        }
        // 타임라인 드래그 중 언마운트 시 window 리스너 정리
        this.endTimelineDrag();
    }

    // 5단계: 필드별 dirty 여부
    isFieldDirty = (field) => {
        if (!this.settingsSnapshot) return false;
        return this.boosterSetting[field] !== this.settingsSnapshot[field];
    }

    // 변경된 설정 항목 라벨 목록 (sticky 저장 바 태그용 — 시작/종료 시간은 '발송 시간대' 하나로 묶음)
    getDirtySettingLabels = () => {
        const labels = [];
        if (this.isFieldDirty('isSendMsg')) labels.push('자동 발송');
        if (this.isFieldDirty('firstSend')) labels.push('첫 발송 시점');
        if (this.isFieldDirty('sendStartTime') || this.isFieldDirty('sendEndTime')) labels.push('발송 시간대');
        if (this.isFieldDirty('sendInterval')) labels.push('재발송 주기');
        if (this.isFieldDirty('sendCount')) labels.push('재발송 횟수');
        return labels;
    }

    // snapshot 과 비교해 dirty 재계산 — 값을 원래대로 되돌리면 저장 바가 자동으로 사라짐 (위젯 설정과 동일한 동작)
    @action
    recomputeSettingsDirty = () => {
        if (!this.settingsSnapshot) {
            this.isSettingsDirty = true;
            return;
        }
        this.isSettingsDirty = this.SETTINGS_FIELDS.some(f => this.boosterSetting[f] !== this.settingsSnapshot[f]);
    }

    // ===== 발송 시간대 타임라인 (눈금 직접 드래그 컨트롤) =====
    // sendStartTime/sendEndTime 의 안전한 숫자 값 (0시도 유효값으로 처리)
    get sendStartHour() {
        const v = this.boosterSetting.sendStartTime;
        return Number.isFinite(v) ? v : 6;
    }
    get sendEndHour() {
        const v = this.boosterSetting.sendEndTime;
        return Number.isFinite(v) ? v : 18;
    }

    @observable draggingHandle = null; // 'start' | 'end' | null
    timelineEl = null;

    setTimelineRef = (el) => { this.timelineEl = el; }

    // 포인터 좌표 → 시간(0~24) 변환
    timelineHourFromEvent = (e) => {
        if (!this.timelineEl) return null;
        const rect = this.timelineEl.getBoundingClientRect();
        if (!rect.width) return null;
        const clientX = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
        const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        return Math.round(ratio * 24);
    }

    @action
    applyTimelineHour = (handle, hour) => {
        // 범위 클램프는 updateSettingField 가 담당 (시작 ≤ 종료-1, 종료는 자동으로 움직이지 않음)
        this.updateSettingField(handle === 'start' ? 'sendStartTime' : 'sendEndTime', hour, 'int');
    }

    @action
    startTimelineDrag = (handle, e) => {
        if (e) {
            e.stopPropagation();
            if (e.type === 'mousedown') e.preventDefault(); // 드래그 중 텍스트 선택 방지
        }
        this.draggingHandle = handle;
        window.addEventListener('mousemove', this.onTimelineDragMove);
        window.addEventListener('mouseup', this.endTimelineDrag);
        window.addEventListener('touchmove', this.onTimelineDragMove, { passive: false });
        window.addEventListener('touchend', this.endTimelineDrag);
    }

    // 눈금 영역을 누르면 가까운 핸들을 그 위치로 이동시킨 뒤 바로 드래그 시작
    @action
    onTimelineBarDown = (e) => {
        const hour = this.timelineHourFromEvent(e);
        if (hour == null) return;
        const handle = Math.abs(hour - this.sendStartHour) <= Math.abs(hour - this.sendEndHour) ? 'start' : 'end';
        this.applyTimelineHour(handle, hour);
        this.startTimelineDrag(handle, e);
    }

    onTimelineDragMove = (e) => {
        if (!this.draggingHandle) return;
        if (e.cancelable) e.preventDefault(); // 터치 드래그 중 화면 스크롤 방지
        const hour = this.timelineHourFromEvent(e);
        if (hour == null) return;
        this.applyTimelineHour(this.draggingHandle, hour);
    }

    @action
    endTimelineDrag = () => {
        this.draggingHandle = null;
        window.removeEventListener('mousemove', this.onTimelineDragMove);
        window.removeEventListener('mouseup', this.endTimelineDrag);
        window.removeEventListener('touchmove', this.onTimelineDragMove);
        window.removeEventListener('touchend', this.endTimelineDrag);
    }

    // 키보드 접근성: 방향키 ±1시간, Home/End 양 끝
    onTimelineHandleKeyDown = (handle, e) => {
        const cur = handle === 'start' ? this.sendStartHour : this.sendEndHour;
        let next = null;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = cur - 1;
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = cur + 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = 24;
        if (next === null) return;
        e.preventDefault();
        this.applyTimelineHour(handle, next);
    }

    @action
    init = async () => {
        if (this.props.isLogin) {
            // basic
            this.isLogin = this.props.isLogin;
            this.teamUser = this.props.me;
            this.store = this.props.me.store ? this.props.me.store : {};
            this.permissions = this.props.me.permissions;

            this.boosterSetting.store_id = this.teamUser.selStore_id;
            this.boosterSetting.shopNo = this.teamUser.selShopNo || 1;
            // this.boosterSetting.kakaoPlusid = this.store.kakaoPlusid && this.store.kakaoSenderkey ? this.store.kakaoPlusid : "";

            // Load settings
            this.getSettings();

            // 알림톡 경유 리뷰 작성 시간대 분포 (발송 시간대 설정 참고용 — 실패/데이터 없음 시 조용히 미표시)
            this.props.getAlimReviewHourStats(
                { store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo || 1 },
                (res) => {
                    // 스토어 액션은 { data: { hours, total, ... } } 래퍼를 넘김 (getBoosterSetting 과 동일 패턴)
                    const stats = res && res.data;
                    if (stats && stats.hours && stats.total > 0) this.alimHourStats = stats;
                }
            );
        }
    };

    @action
    getSettings = async () => {
        let _this = this;
        this.isLoading = true;
        const params = {
            store_id: this.teamUser.selStore_id,
            shopNo: this.teamUser.selShopNo || 1
        };

        this.props.getBoosterSetting( params, function(res) {
            console.log(res)
            _this.isLoading = false;
            if(res.errors && res.errors.length > 0) {
                toast(res.errors[0].message);
            }
            else {
                if(res.data) {
                    _this.boosterSetting = _.defaults(res.data, _this.boosterSetting);
                    if(!_this.boosterSetting.temp) {
                        _this.boosterSetting.temp = {}
                    }
                }
                // 설정 로드 직후 snapshot 갱신 → 변경 추적 시작점
                _this.snapshotSettings();
                // 알리고에서 현재 senderkey 의 채널 상태(A 정상 / S 차단 / D 삭제) 조회
                _this.loadChannelStatusFromAligo();
            }
        });

    };

    @action loadChannelStatusFromAligo = async () => {
        const localKey = this.boosterSetting.kakaoSenderkey;
        if (!localKey) {
            this.channelStatus = '';
            return;
        }
        try {
            const res = await this.props.getAligoProfileList();
            if (res && Array.isArray(res.list)) {
                // 알리고 응답은 senderKey(카멜)지만 일부 응답에서 senderkey 도 가능하므로 둘 다 대응
                const matched = res.list.find(ch => (ch.senderKey || ch.senderkey) === localKey);
                this.channelStatus = matched ? (matched.status || '') : '';
                console.log('[kakaoMsgSetting] channelStatus =', this.channelStatus, 'localKey =', localKey, 'matched =', matched);

                // 차단(S) 상태이고 현재 자동 발송이 켜져 있으면 강제 OFF + DB 저장
                if ((this.channelStatus + '').toUpperCase() === 'S' && this.boosterSetting.isSendMsg) {
                    this.boosterSetting.isSendMsg = false;
                    try {
                        await this.setBoosterSetting();
                        toast.error('카카오 채널이 차단되어 알림톡 자동 발송이 OFF로 변경되었습니다.');
                        this.snapshotSettings();
                    } catch (saveErr) {
                        console.error('[kakaoMsgSetting] 차단 자동 OFF 저장 실패:', saveErr);
                    }
                }
            } else {
                this.channelStatus = '';
            }
        } catch (e) {
            console.error('[kakaoMsgSetting] loadChannelStatusFromAligo error:', e);
            this.channelStatus = '';
        }


        // this.props.getApplyShop( params, function(res) {
        //     if(res.errors && res.errors.length > 0) {
        //         toast(res.errors[0].message);
        //     }
        //     else {
        //         Storage.setObject('shops', res.data);
        //         _this.shops = res.data;
        //         console.log(_this.shops)
        //
        //     }
        // });

        // await this.props.getDoc('getResponseBotSettings', params, (res) => {
        //     if (res && res.data) {
        //         this.boosterSetting = res.data.settings || this.boosterSetting;
        //         this.channelType = res.data.channelType || this.channelType;
        //         this.messageLimit = res.data.messageLimit || this.messageLimit;
        //         this.messageLimitCount = res.data.messageLimitCount || this.messageLimitCount;
        //     }
        //     this.isLoading = false;
        // });

        // 설정 값 처리 후 아래 코드 삭제

    };

    @action
    saveSettings = async () => {
        this.isLoading = true;
        // const params = {
        //     store_id: this.teamUser.selStore_id,
        //     shopNo: this.teamUser.selShopNo || 1,
        //     settings: this.boosterSetting,
        //     channelType: this.channelType,
        //     messageLimit: this.messageLimit,
        //     messageLimitCount: this.messageLimitCount
        // };
        //
        // await this.props.updateDoc('updateResponseBotSettings', params, (res) => {
        //     if (res.errors && res.errors.length > 0) {
        //         toast(res.errors[0].message);
        //     } else {
        //         toast("설정이 저장되었습니다.");
        //     }
        //     this.isLoading = false;
        // });
    };

    @action
    onToggleChange = (section) => {
        this.boosterSetting[section].enabled = !this.boosterSetting[section].enabled;
    };

    @action
    onRadioChange = (name, value, targetData, valType) => {
        targetData[name] = valType === "int" ?  parseInt(value) : value;
    };

    @action
    onInputChange = (event) => {
        const { value, name } = event.target;
        if(name === "phonenumber") {
            this.teamUser.tel = value;
        }
        this.boosterSetting[name] = value;
    };

    @action
    onChangeChecked = async (event, targetObj, keyArray) => {
        if(keyArray[0]) {
            targetObj[keyArray[0]] = !targetObj[keyArray[0]];
        }
    };

    @action
    onChangeSelect = async (event) => {
        const { value, name } = event.target;
        if(name === "firstCate") {
            this.category[0] = value;
            let secondCate =  _.groupBy(categoryCode.data.secondBusinessType, "parentCode");
            this.categoryOptions.secondCate = secondCate[value];
        }
        else if(name === "secondCate") {
            this.category[1] = value;
            let thirdCate =  _.groupBy(categoryCode.data.thirdBusinessType, "parentCode");
            this.categoryOptions.thirdCate = thirdCate[value];
        }
        else if(name === "thirdCate") {
            this.category[2] = value;
            this.boosterSetting.categorycode = value;
        }
        else if(name === "sendStartTime" || name === "sendEndTime") {
            // 종료 시간은 자동으로 움직이지 않음 — 시작/종료가 서로를 넘지 못하게 입력값 자체를 클램프 (updateSettingField 와 동일 정책)
            let v = parseInt(value);
            if(name === "sendStartTime") {
                v = Math.max(0, Math.min(v, this.sendEndHour - 1));
            }
            else {
                v = Math.min(23, Math.max(v, this.sendStartHour + 1));
            }
            this.boosterSetting[name] = v;
        }
    };

    @action
    onChangeStep = async (stepNo) => {
        let _this = this;
        if(!this.boosterSetting.kakaoPlusid || this.boosterSetting.kakaoPlusid === "") {
            alert("카카오 채널 검색용 아이디를 입력해 주세요.");
            return false;
        }
        if(stepNo > 2) {
            if(!this.boosterSetting.categorycode || this.boosterSetting.categorycode === "") {
                alert("카테고리를 선택해 주세요.");
                return false;
            }
            if(!this.boosterSetting.phonenumber || this.boosterSetting.phonenumber === "") {
                alert("전화번호를 입력해 주세요.");
                return false;
            }

        }
        if(stepNo > 4) {
            if(!this.boosterSetting.authnum || this.boosterSetting.authnum === "") {
                alert("인증번호를 입력해 주세요.");
                return false;
            }
        }

        if(stepNo === 2 || stepNo === 4) {
            stepNo = 4;
            this.authStep = stepNo;
        }
        if(stepNo === 3) {
            this.props.addKakaoProfile(this.boosterSetting, function(resp) {
                let res = resp.data;
                if(res) {
                    if(parseInt(res.code) < 0 || parseInt(res.code) > 100) {
                        //{code: -99, message: "이미등록된 플러스친구 ID입니다."}
                        alert(res.message);
                    }
                    else {
                        //console.log("s", res);
                        if(res.kakaoSenderkey) {
                            toast("카카오 채널 연동이 완료되었습니다.");
                            _this.boosterSetting = res;
                        }
                        else {
                            _this.onChangeStep(4);
                        }

                    }
                }
                else {
                    //console.log(res);
                }

            });
        }
        if(stepNo === 5) {
            this.props.addKakaoProfile(this.boosterSetting, function(resp) {
                let res = resp.data;
                if(res && res.code) {
                    if(res.code < 0) {
                        //{code: -99, message: "이미등록된 플러스친구 ID입니다."}
                        alert(res.message);
                    }
                    else {
                        _this.authStep = 1;
                        _this.boosterSetting = resp.data;
                    }
                }
                else {
                    _this.boosterSetting = resp.data;
                    toast("카카오 채널 연동이 완료되었습니다.");
                }


            });
        }

    };

    onChangeTempltContentValue = async (event, tempObj, temp) => {
        const { value, name } = event.target;
        if(name === "templtContent") {
            if(!tempObj[temp]) { tempObj[temp] = {} }
            if(!tempObj[temp][name]) { tempObj[temp][name] = this.templtContent }

            tempObj[temp][name] = value;
        }
    };

    setBoosterSetting = async() => {
        // console.log('updateMassReview', updateData);
        let updateData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
            params: _.omit(this.boosterSetting, ['store_id', 'shopNo', 'kakaoPlusid']),
        }
        this.props.setBoosterSetting(updateData, function(res) {
            console.log(res);

        });
    }

    setKakaoTemp = async(type, temp, tempIndex) => {
        let _this = this;
        _this.isLoading = true;
        let updateData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
            params : {type : type ? type : ''}
            //params: _.omit(this.boosterSetting, ['store_id', 'shopNo', 'kakaoPlusid']),
        }

        if(type === "use") {
            updateData.params.tempIndex = tempIndex;
        }
        else if(type === "del") {
            updateData.params.tempIndex = tempIndex;
            updateData.params.templtCode = temp.templtCode;
        }
        else if(type === "genTemp") {
            if(temp) {
                updateData.params.templtContent = temp.templtContent;
            }
            // 채널추가(AC) 버튼 옵션 — 체크 시 템플릿 버튼 최상단에 "채널 추가" 버튼이 등록됨
            updateData.params.addChannelButton = !!(temp && temp.addChannelButton);
        }
        else if(type === "mod") {
            // updateData.params = _.pick(this.boosterSetting, 'store_id', 'shopNo', 'kakaoPlusid');
            updateData.params.templtCode = temp.templtCode;
            updateData.params.templtContent = temp.templtContent;
            updateData.params.tempIndex = tempIndex;
        }
        else {
            updateData.params = _.pick(this.boosterSetting, ['store_id', 'shopNo', 'kakaoPlusid']);
        }
        // _this.isLoading = false;
        this.props.setKakaoTemp(updateData, function(res) {
            _this.isLoading = false;
            // 백엔드가 {data: {errors: [...]}} 형태로 실패 응답을 보내면 사용자에게 알림 후 처리 중단
            if (res && res.data && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
                toast.error(res.data.errors[0].message || '템플릿 처리에 실패했습니다.');
                return;
            }

            // 성공 처리 — reload 대신 화면 내 상태 갱신
            if (type === "genTemp") {
                // 편집 패널 닫기 (취소 버튼과 동일한 cleanup)
                _this.isTempEdit[tempIndex] = false;
                _this.boosterSetting[tempIndex] = null;
                if (_this.selectedTemplateSlot === tempIndex) _this.selectedTemplateSlot = null;
                toast.success('템플릿 생성 요청을 보냈습니다. 카카오 심사 후 사용 가능합니다.');
            } else if (type === "del") {
                toast.success('템플릿이 삭제되었습니다.');
            }

            // BoosterSetting 재조회로 슬롯/심사 상태 동기화 (getBoosterSetting 이 알리고 templateList 와도 동기화함)
            _this.getSettings();
        });
    }

    showCommnet = async(type, temp, tempIndex) => {
        if(temp && temp.comments && temp.comments[0]) {
            this.modals.data = temp.comments[0];
        }
        else {
            this.modals.data = { commentContent: "반려 사유 정보가 없습니다.\n\n카카오 알림톡은 등록 후 카카오에서 승인된 문구만 발송 가능합니다.\n가이드: https://kakaobusiness.gitbook.io/main/ad/infotalk/content-guide" };
        }
        this.modals.isTempComment = true;
    }

    modalToggle = function(target, data) {
        if(!target) {
            for( var i in this.modals) {
                if(i.indexOf('is') === 0) {
                    this.modals[i] = false;
                }
            }
        }
        else {
            this.modals[target] = !this.modals[target];
        }
    };

    deleteKakaoTemp = async(temp) => {
        //todo 문의/요청 게시판으로 처리
    }

    deleteKakaoChannel = async() => {
        if (window.confirm('카카오 채널 등록을 삭제하시겠습니까?\n삭제 시 모든 템플릿과 설정이 초기화됩니다.')) {
            let _this = this;
            this.isLoading = true;
            
            let updateData = {
                store_id: this.store._id,
                shopNo: this.teamUser.selShopNo
            }
            
            this.props.removeKakaoTemp(updateData, function(res) {
                _this.isLoading = false;
                if (res.errors && res.errors.length > 0) {
                    toast(res.errors[0].message);
                } else {
                    toast('카카오 채널 등록이 삭제되었습니다.');
                    // 설정 초기화
                    _this.boosterSetting.isKakaoPlusidAuth = false;
                    _this.boosterSetting.kakaoPlusid = "";
                    _this.boosterSetting.kakaoSenderkey = "";
                    _this.boosterSetting.temp = {};
                    _this.boosterSetting.temp_0 = null;
                    _this.boosterSetting.temp_1 = null;
                    _this.boosterSetting.temp_2 = null;
                    _this.authStep = 1;
                    // window.location.reload();
                }
            });
        }
    }

    adminCusData = async() => {
        let updateData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        }
        // console.log('updateMassReview', updateData);
        this.props.adminCusData(updateData, function(res) {
            console.log(res);

        });
    }
    // todo
    //  1. 프로필 인증 -> 키(senderkey) 정보 데이터베이스 저장
    //  2. 템플릿 선택 및 템플릿 등록 및 검수 4-5일간의 검수
    //  3. 주문데이터 처리
    //  4. 발송 처리

    openTestSendModal = (templtCode) => {
        this.testSend.templtCode = templtCode;
        this.testSend.phoneNumber = this.boosterSetting.phonenumber || "";
        this.testSend.writerName = "";
        // 상품 선택 초기화
        this.testSend.platformProductId = "";
        this.testSend.productName = "";
        this.testSend.productImage = "";
        this.productSearch.isOpen = false;
        this.productSearch.keyword = "";
        this.productSearch.results = [];
        this.productSearch.page = 1;
        this.productSearch.totalPages = 1;
        this.modals.isTestSend = true;
    }

    @action toggleProductSearch = () => {
        this.productSearch.isOpen = !this.productSearch.isOpen;
        if (this.productSearch.isOpen && this.productSearch.results.length === 0) {
            this.searchTestProduct();
        }
    }

    @action searchTestProduct = async (page) => {
        if (!this.teamUser.selStore_id) return;
        this.productSearch.page = page || 1;
        this.productSearch.isSearching = true;
        try {
            const res = await this.props.getProductList({
                store_id: this.teamUser.selStore_id,
                shopNo: this.teamUser.selShopNo || 1,
                page: this.productSearch.page,
                limit: 20,
                searchParams: this.productSearch.keyword ? { keyword: this.productSearch.keyword } : {}
            });
            this.productSearch.results = (res && res.docs) ? res.docs : [];
            this.productSearch.totalPages = (res && res.totalPages) || 1;
        } catch (e) {
            toast.error('상품 검색에 실패했습니다.');
        } finally {
            this.productSearch.isSearching = false;
        }
    }

    @action goTestProductPage = (p) => {
        if (p < 1 || p > this.productSearch.totalPages) return;
        this.searchTestProduct(p);
    }

    @action pickTestProduct = (p) => {
        this.testSend.platformProductId = String(p.platformProductId || '');
        this.testSend.productName = p.productName || '';
        this.testSend.productImage = (p.images && (p.images.s_2 || p.images.s_1 || p.images.t_2)) || p.image || '';
        this.productSearch.isOpen = false;
    }

    @action clearTestProduct = () => {
        this.testSend.platformProductId = "";
        this.testSend.productName = "";
        this.testSend.productImage = "";
    }

    sendTestKakao = async () => {
        if (!this.testSend.writerName || this.testSend.writerName.trim() === "") {
            toast("작성자 이름을 입력해 주세요.");
            return;
        }
        if (!this.testSend.phoneNumber || this.testSend.phoneNumber === "") {
            toast("수신 전화번호를 입력해 주세요.");
            return;
        }

        this.isLoading = true;
        let _this = this;

        let sendData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
            phoneNumber: this.testSend.phoneNumber,
            templtCode: this.testSend.templtCode,
            writerName: this.testSend.writerName.trim(),
        };
        // 상품을 선택한 경우에만 전달 → 서버가 해당 상품의 테스트 주문을 만들어 작성 링크를 생성
        if (this.testSend.platformProductId) {
            sendData.platformProductId = this.testSend.platformProductId;
        }

        this.props.sendTestKakao(sendData, function (res) {
            _this.isLoading = false;
            if (res && res.errors && res.errors.length > 0) {
                toast(res.errors[0].message);
            } else {
                toast("테스트 알림톡이 발송되었습니다.");
                _this.modals.isTestSend = false;
            }
        });
    }

    @action
    goToCharge = () => {
        // 5단계: 잔량 영역에 펄스 애니메이션 → 짧은 지연 후 이동
        this.isQuotaPulsing = true;
        setTimeout(() => {
            this.isQuotaPulsing = false;
            window.location.href = '/msgOrder';
        }, 650);
    }

    @action
    toggleSection = (key) => {
        this.expandedSections[key] = !this.expandedSections[key];
    }

    @action
    selectTemplateSlot = (slot) => {
        this.selectedTemplateSlot = slot;
    }

    @action
    snapshotSettings = () => {
        const snap = {};
        this.SETTINGS_FIELDS.forEach(f => { snap[f] = this.boosterSetting[f]; });
        this.settingsSnapshot = snap;
        this.isSettingsDirty = false;
    }

    @action
    revertSettings = () => {
        if (this.settingsSnapshot) {
            this.SETTINGS_FIELDS.forEach(f => {
                this.boosterSetting[f] = this.settingsSnapshot[f];
            });
        }
        this.isSettingsDirty = false;
    }

    @action
    updateSettingField = (field, value, valType) => {
        let v = valType === 'int' ? parseInt(value) : value;
        // 발송 시간대 가드: 종료 시간은 자동으로 움직이지 않음 — 시작/종료가 서로를 넘지 못하게 입력값 자체를 클램프
        if (field === 'sendStartTime') {
            v = Math.max(0, Math.min(v, this.sendEndHour - 1));
        }
        else if (field === 'sendEndTime') {
            v = Math.min(23, Math.max(v, this.sendStartHour + 1));
        }
        this.boosterSetting[field] = v;
        this.recomputeSettingsDirty();
    }

    @action
    saveSettingsAndSnapshot = async () => {
        await this.setBoosterSetting();
        toast.success('발송 설정이 저장되었습니다.');
        this.snapshotSettings();
    }

    // 분 단위 → "오전/오후 H시" 한글 표기
    formatHour = (hour) => {
        if (hour === 0) return '자정';
        if (hour === 12) return '정오';
        if (hour < 12) return `오전 ${hour}시`;
        return `오후 ${hour - 12}시`;
    }

    @action
    openUseChangeModal = (slot, temp) => {
        this.useChangeTarget = { slot, temp };
        this.modals.isUseChange = true;
        this.openMoreMenuSlot = null;
    }

    @action
    confirmUseChange = () => {
        if (!this.useChangeTarget || !this.useChangeTarget.temp) return;
        const { slot, temp } = this.useChangeTarget;
        this.modals.isUseChange = false;
        this.setKakaoTemp("use", temp, slot);
    }

    @action
    toggleMoreMenu = (slot, event) => {
        if (this.openMoreMenuSlot === slot) {
            this.openMoreMenuSlot = null;
            this.moreMenuPos = null;
            return;
        }
        // 클릭한 버튼 기준 popover 위치 계산 (portal 로 body 에 렌더링)
        const btn = event && event.currentTarget ? event.currentTarget : null;
        if (btn) {
            const rect = btn.getBoundingClientRect();
            const popWidth = 240;
            const top = rect.bottom + 6;
            let left = rect.right - popWidth; // 우측 정렬
            if (left < 8) left = 8;             // viewport 좌측 클램프
            const maxLeft = window.innerWidth - popWidth - 8;
            if (left > maxLeft) left = maxLeft; // viewport 우측 클램프
            this.moreMenuPos = { top, left };
        } else {
            this.moreMenuPos = null;
        }
        this.openMoreMenuSlot = slot;
    }

    @action
    closeMoreMenu = () => {
        this.openMoreMenuSlot = null;
        this.moreMenuPos = null;
    }


    render() {
        function TempInspStatus(props) {
            //승인상태 (REG: 등록, REQ: 심사요청, APR: 승인, REJ: 반려)
            switch (props.inspStatus){
                case "REG" :
                    return <Badge outline theme="info">등록중</Badge>;
                case "REQ" :
                    return <Badge outline theme="info">심사요청</Badge>;
                case "APR" :
                    return props.isUse
                        ? <Badge theme="primary">사용중</Badge>
                        : <Badge outline theme="success">승인완료</Badge>;
                case "REJ" :
                    return <Badge outline theme="warning">반려</Badge>;
                default :
                    return null;
            }
        }

        // ========== 리디자인 헬퍼 ==========
        const isChannelRegistered = !!this.boosterSetting.isKakaoPlusidAuth;
        const activeTemp = this.boosterSetting.temp;
        // 사용중(활성) 템플릿 존재 여부 — 없으면 알림톡 자동 발송을 켤 수 없다
        const hasActiveTemplate = !!(activeTemp && activeTemp.templtCode);
        const tempSlots = ['temp_0', 'temp_1', 'temp_2'];
        const tempCount = tempSlots.filter(s => this.boosterSetting[s] && this.boosterSetting[s].templtCode).length;

        // 잔량 시각화: 10,000건을 기준으로 fill %, 200건 이하 위험 / 300건 이하 경고
        const quota = this.store.messageQuota || 0;
        const quotaMax = 10000;
        const quotaPct = Math.min(100, Math.max(2, Math.round((quota / quotaMax) * 100)));
        const quotaLevel = quota <= 200 ? 'danger' : (quota <= 300 ? 'warn' : 'ok');
        const quotaAlertText = quotaLevel === 'danger' ? '잔량 부족' : (quotaLevel === 'warn' ? '충전 권장' : null);
        // 미리보기 대상: 선택된 슬롯 → 활성 템플릿 → 첫 등록 템플릿
        let previewSlot = null;
        if (this.selectedTemplateSlot && this.boosterSetting[this.selectedTemplateSlot] && this.boosterSetting[this.selectedTemplateSlot].templtContent) {
            previewSlot = this.selectedTemplateSlot;
        } else if (activeTemp && activeTemp.templtCode) {
            // activeTemp 의 templtCode 와 일치하는 슬롯 찾기
            previewSlot = tempSlots.find(s => this.boosterSetting[s] && this.boosterSetting[s].templtCode === activeTemp.templtCode) || null;
        }
        const previewTemp = previewSlot ? this.boosterSetting[previewSlot] : (activeTemp && activeTemp.templtCode ? activeTemp : null);
        const editingSlot = tempSlots.find(s => this.isTempEdit[s]);
        // sticky 저장 바 태그용 — 변경된 설정 항목 라벨
        const dirtySettingLabels = this.getDirtySettingLabels();

        return (
            <div className="main-content kakao-msg-redesign">
                <PageTitle />
                {( this.isLogin && this.teamUser.emailId ) ? (
                    <div className="setting-box">
                        {/* ========== 섹션 1: 알림톡 현황 대시보드 ========== */}
                        <Card className="status-dashboard mb-3">
                            <CardBody>
                                <Row className="align-items-center">
                                    {/* 알림톡 잔량 — 프로그레스 바 + 숫자 */}
                                    <Col md="4" sm="12" className={`status-item quota-item quota-${quotaLevel} ${this.isQuotaPulsing ? 'is-pulsing' : ''}`}>
                                        <div className="status-label">
                                            <FeatherIcon icon="message-circle" size="14" />
                                            <span>보유 알림톡</span>
                                            {quotaAlertText && (
                                                <Badge theme={quotaLevel === 'danger' ? 'danger' : 'warning'} className="quota-alert-badge">
                                                    <FeatherIcon icon="alert-triangle" size="10" style={{marginRight: '3px'}} />
                                                    {quotaAlertText}
                                                </Badge>
                                            )}
                                        </div>
                                        <div className="quota-row">
                                            <div className="quota-numeric">
                                                <strong className="quota-num">{quota.toLocaleString()}</strong>
                                                <span className="unit">건</span>
                                            </div>
                                            <button type="button"
                                                    className={`quota-cta quota-cta-${quotaLevel}`}
                                                    onClick={() => this.goToCharge()}
                                                    aria-label={`알림톡 충전하기. 현재 보유 ${quota.toLocaleString()}건${quotaAlertText ? ', ' + quotaAlertText : ''}`}>
                                                <FeatherIcon icon="zap" size="13" style={{marginRight: '4px'}} aria-hidden="true" />
                                                충전하기
                                            </button>
                                        </div>
                                        <div className="quota-progress">
                                            <div className="quota-progress-track">
                                                <div className="quota-progress-fill" style={{width: `${quotaPct}%`}} />
                                            </div>
                                            <div className="quota-progress-scale">
                                                <span>0</span>
                                                <span>5,000</span>
                                                <span>10,000+</span>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* 카카오 채널 상태 + 등록 정보 */}
                                    <Col md="3" sm="12" className="status-item channel-item">
                                        <div className="status-label">
                                            <FeatherIcon icon="link" size="14" />
                                            <span>카카오 채널</span>
                                            {isChannelRegistered ? (
                                                <Badge theme="success" className="channel-status-badge channel-connected">
                                                    <FeatherIcon icon="check-circle" size="10" style={{marginRight: '3px'}} />
                                                    연결됨
                                                </Badge>
                                            ) : (
                                                <Badge theme="warning" className="channel-status-badge channel-disconnected">
                                                    <FeatherIcon icon="alert-circle" size="10" style={{marginRight: '3px'}} />
                                                    미연결
                                                </Badge>
                                            )}
                                            {/* 알리고 senderkey 상태가 차단(S)이면 차단 라벨 표시 */}
                                            {isChannelRegistered && (this.channelStatus + '').toUpperCase() === 'S' && (
                                                <Badge theme="danger" className="channel-status-badge" style={{marginLeft: '4px'}}>
                                                    <FeatherIcon icon="slash" size="10" style={{marginRight: '3px'}} />
                                                    차단
                                                </Badge>
                                            )}
                                        </div>
                                        {/* 차단 상태 안내 멘트 + 문의 바로가기 */}
                                        {isChannelRegistered && (this.channelStatus + '').toUpperCase() === 'S' && (
                                            <div style={{
                                                marginTop: 8, padding: '8px 10px',
                                                background: '#FEE2E2', border: '1px solid #FECACA',
                                                borderRadius: 6, fontSize: 12, color: '#991B1B', lineHeight: 1.55,
                                                display: 'flex', alignItems: 'flex-start', gap: 8
                                            }}>
                                                <FeatherIcon icon="alert-triangle" size="12" style={{marginTop: 2, flexShrink: 0}}/>
                                                <div style={{flex: 1, minWidth: 0}}>
                                                    현재 카카오 채널이 <b>차단</b> 상태입니다. <b>문의 게시판</b>에 문의를 남겨 주시면 영업일 기준 <b>2~3일 후</b> 처리됩니다.
                                                </div>
                                                <Link
                                                    to="/inquiry"
                                                    style={{
                                                        flexShrink: 0,
                                                        display: 'inline-flex', alignItems: 'center', gap: 3,
                                                        padding: '4px 8px',
                                                        background: '#991B1B', color: '#FFFFFF',
                                                        borderRadius: 4, fontSize: 11, fontWeight: 600,
                                                        textDecoration: 'none', whiteSpace: 'nowrap'
                                                    }}
                                                    title="문의 게시판으로 이동"
                                                >
                                                    문의하기
                                                    <FeatherIcon icon="arrow-right" size="11"/>
                                                </Link>
                                            </div>
                                        )}
                                        {isChannelRegistered ? (
                                            <div className="channel-info-list">
                                                <div className="channel-info-row">
                                                    <FeatherIcon icon="at-sign" size="11" />
                                                    <span className="channel-info-key">채널 ID</span>
                                                    <span className="channel-info-val">{this.boosterSetting.kakaoPlusid}</span>
                                                </div>
                                                {this.boosterSetting.phonenumber && (
                                                    <div className="channel-info-row">
                                                        <FeatherIcon icon="phone" size="11" />
                                                        <span className="channel-info-key">관리자</span>
                                                        <span className="channel-info-val">{this.boosterSetting.phonenumber}</span>
                                                    </div>
                                                )}
                                                <div className="channel-info-actions">
                                                    <button type="button" className="channel-delete-btn"
                                                            onClick={() => this.deleteKakaoChannel()}
                                                            title="카카오 채널 등록을 삭제합니다"
                                                            aria-label="카카오 채널 등록을 완전히 삭제. 모든 템플릿과 설정이 초기화됩니다">
                                                        <FeatherIcon icon="trash-2" size="11" style={{marginRight: '4px'}} aria-hidden="true" />
                                                        채널등록 삭제
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="channel-info-list">
                                                <div className="channel-info-empty">
                                                    아래에서 등록을 진행하세요
                                                </div>
                                            </div>
                                        )}
                                    </Col>

                                    {/* 활성 템플릿 */}
                                    <Col md="2" sm="6" className="status-item">
                                        <div className="status-label">
                                            <FeatherIcon icon="file-text" size="14" />
                                            <span>활성 템플릿</span>
                                        </div>
                                        {activeTemp && activeTemp.templtCode ? (
                                            <>
                                                <div className="status-value">
                                                    <strong>{activeTemp.templtCode}</strong>
                                                </div>
                                                <div className="status-sub">
                                                    <TempInspStatus inspStatus={activeTemp.inspStatus} isUse={true} />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="status-value status-muted">
                                                    <strong>없음</strong>
                                                </div>
                                                <div className="status-sub">템플릿을 등록하세요</div>
                                            </>
                                        )}
                                    </Col>

                                    {/* 알림톡 발송 ON/OFF */}
                                    <Col md="3" sm="12" className="status-item status-toggle">
                                        <div className="status-label">
                                            <FeatherIcon icon="power" size="14" />
                                            <span>알림톡 발송</span>
                                        </div>
                                        {isChannelRegistered ? (
                                            <div className="status-value">
                                                <FormCheckbox
                                                    toggle small
                                                    disabled={!hasActiveTemplate && !this.boosterSetting.isSendMsg}
                                                    checked={!!this.boosterSetting.isSendMsg}
                                                    onChange={event => {
                                                        // 사용중 템플릿이 없으면 켤 수 없음 (끄는 것은 허용)
                                                        if (!hasActiveTemplate && !this.boosterSetting.isSendMsg) return;
                                                        this.onChangeChecked(event, this.boosterSetting, ['isSendMsg']);
                                                        // setBoosterSetting 은 boosterSetting 전체를 저장하므로 snapshot 도 동기화 (dirty 해제)
                                                        this.setBoosterSetting();
                                                        this.snapshotSettings();
                                                    }}>
                                                    <strong style={{color: this.boosterSetting.isSendMsg ? '#10b981' : '#999'}}>
                                                        {this.boosterSetting.isSendMsg ? 'ON' : 'OFF'}
                                                    </strong>
                                                </FormCheckbox>
                                                {!hasActiveTemplate && (
                                                    <div className="status-sub" style={{color: '#b45309'}}>
                                                        사용중 템플릿이 없어 켤 수 없습니다
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="status-value status-muted">
                                                <strong>채널 등록 후 가능</strong>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* ========== 섹션 2: 템플릿 관리 (채널 등록 완료시) ========== */}
                        {isChannelRegistered && (
                            <Card className="mb-3 redesign-section">
                                <CardHeader className="collapsible-header"
                                            role="button"
                                            tabIndex={0}
                                            aria-expanded={this.expandedSections.templates}
                                            aria-controls="section-templates-body"
                                            onClick={() => this.toggleSection('templates')}
                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleSection('templates'); } }}>
                                    <div className="header-left">
                                        <FeatherIcon icon="layout" size="16" />
                                        <h5 className="m-0">템플릿 관리</h5>
                                        <span className="header-desc">발송할 알림톡 템플릿을 등록·관리합니다 ({tempCount}/3)</span>
                                    </div>
                                    <FeatherIcon icon={this.expandedSections.templates ? 'chevron-up' : 'chevron-down'} size="18" />
                                </CardHeader>
                                <Collapse open={this.expandedSections.templates}>
                                    <CardBody>
                                        <Row>
                                            {/* 좌측: 템플릿 리스트 (테이블) */}
                                            <Col lg="7" md="12">
                                                <div className="template-list-table">
                                                    <table>
                                                        <colgroup>
                                                            <col width="40" />
                                                            <col />
                                                            <col width="100" />
                                                            <col width="220" />
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>템플릿 코드</th>
                                                                <th>상태</th>
                                                                <th className="text-right">관리</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {tempSlots.map((slot, idx) => {
                                                                const t = this.boosterSetting[slot];
                                                                const isFilled = t && t.templtCode;
                                                                const isActive = isFilled && activeTemp && activeTemp.templtCode === t.templtCode;
                                                                const isSelected = previewSlot === slot;

                                                                if (!isFilled) {
                                                                    return (
                                                                        <tr key={slot} className="empty-slot">
                                                                            <td className="text-center text-muted">{idx + 1}</td>
                                                                            <td className="text-muted">— 비어있음 —</td>
                                                                            <td>—</td>
                                                                            <td className="text-right">
                                                                                <Button size="sm" theme="primary"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            this.isTempEdit[slot] = true;
                                                                                            this.boosterSetting[slot] = {templtContent: this.templtContent};
                                                                                            this.selectTemplateSlot(slot);
                                                                                        }}>
                                                                                    <FeatherIcon icon="plus" size="11" style={{marginRight: '3px'}} />템플릿 만들기
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }

                                                                return (
                                                                    <tr key={slot}
                                                                        className={`template-row ${isSelected ? 'selected' : ''} ${isActive ? 'active' : ''}`}
                                                                        tabIndex={0}
                                                                        role="button"
                                                                        aria-pressed={isSelected}
                                                                        aria-label={`템플릿 ${t.templtCode} 선택. ${isActive ? '현재 사용 중. ' : ''}미리보기를 표시합니다`}
                                                                        onClick={() => this.selectTemplateSlot(slot)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                                e.preventDefault();
                                                                                this.selectTemplateSlot(slot);
                                                                            }
                                                                        }}>
                                                                        <td className="text-center text-muted">{idx + 1}</td>
                                                                        <td>
                                                                            <div className="template-code-wrap">
                                                                                {isActive && (
                                                                                    <span className="active-indicator" title="현재 사용 중인 템플릿">
                                                                                        <span className="active-dot" />
                                                                                        <span className="active-label">사용중</span>
                                                                                    </span>
                                                                                )}
                                                                                <div className="template-code">{t.templtCode}</div>
                                                                            </div>
                                                                        </td>
                                                                        <td><TempInspStatus inspStatus={t.inspStatus} isUse={isActive} /></td>
                                                                        <td className="text-right">
                                                                            <div className="template-actions">
                                                                                {!isActive && t.inspStatus === 'APR' && (
                                                                                    <Button size="sm" theme="primary"
                                                                                            onClick={(e) => { e.stopPropagation(); this.openUseChangeModal(slot, t); }}>
                                                                                        <FeatherIcon icon="check" size="11" style={{marginRight: '3px'}} />사용하기
                                                                                    </Button>
                                                                                )}
                                                                                {isActive && t.inspStatus === 'APR' && (
                                                                                    <Button size="sm" theme="success"
                                                                                            onClick={(e) => { e.stopPropagation(); this.openTestSendModal(t.templtCode); }}>
                                                                                        <FeatherIcon icon="send" size="11" style={{marginRight: '3px'}} />테스트
                                                                                    </Button>
                                                                                )}
                                                                                {t.inspStatus === 'REJ' && (
                                                                                    <Button size="sm" theme="warning"
                                                                                            onClick={(e) => { e.stopPropagation(); this.showCommnet("use", t, slot); }}>
                                                                                        반려 사유
                                                                                    </Button>
                                                                                )}
                                                                                {t.inspStatus === 'REG' && (
                                                                                    <Button size="sm" theme="light"
                                                                                            onClick={(e) => { e.stopPropagation(); window.location.reload(); }}>
                                                                                        <FeatherIcon icon="refresh-cw" size="11" style={{marginRight: '3px'}} />새로고침
                                                                                    </Button>
                                                                                )}

                                                                                {/* 더보기(⋯) 메뉴 */}
                                                                                <div className="more-menu-wrap">
                                                                                    <button type="button" className="more-menu-btn"
                                                                                            onClick={(e) => { e.stopPropagation(); this.toggleMoreMenu(slot, e); }}
                                                                                            title="더보기"
                                                                                            aria-label={`템플릿 ${t.templtCode} 더보기 메뉴`}
                                                                                            aria-haspopup="menu"
                                                                                            aria-expanded={this.openMoreMenuSlot === slot}>
                                                                                        <FeatherIcon icon="more-vertical" size="14" aria-hidden="true" />
                                                                                    </button>
                                                                                    {this.openMoreMenuSlot === slot && ReactDOM.createPortal(
                                                                                        <div className="kakao-msg-redesign"><div className="template-list-table">
                                                                                            <div className="more-menu-backdrop" onClick={(e) => { e.stopPropagation(); this.closeMoreMenu(); }} />
                                                                                            <div className="more-menu-popover more-menu-popover--portal"
                                                                                                 style={this.moreMenuPos ? {position: 'fixed', top: this.moreMenuPos.top, left: this.moreMenuPos.left, width: 240} : null}>
                                                                                                {t.inspStatus === 'REJ' && (
                                                                                                    <button type="button" className="more-menu-item"
                                                                                                            onClick={(e) => { e.stopPropagation(); this.closeMoreMenu(); this.showCommnet("use", t, slot); }}>
                                                                                                        <FeatherIcon icon="alert-circle" size="13" />
                                                                                                        반려 내용 보기
                                                                                                    </button>
                                                                                                )}
                                                                                                {t.inspStatus === 'APR' && !isActive && (
                                                                                                    <button type="button" className="more-menu-item"
                                                                                                            onClick={(e) => { e.stopPropagation(); this.closeMoreMenu(); this.openTestSendModal(t.templtCode); }}>
                                                                                                        <FeatherIcon icon="send" size="13" />
                                                                                                        테스트 발송
                                                                                                    </button>
                                                                                                )}
                                                                                                {!isActive ? (
                                                                                                    <button type="button" className="more-menu-item more-menu-item-danger"
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                this.closeMoreMenu();
                                                                                                                if (window.confirm('이 템플릿을 삭제하시겠습니까?\n삭제 후에는 복구할 수 없습니다.')) {
                                                                                                                    this.setKakaoTemp('del', t, slot);
                                                                                                                }
                                                                                                            }}>
                                                                                                        <FeatherIcon icon="trash-2" size="13" />
                                                                                                        템플릿 삭제
                                                                                                    </button>
                                                                                                ) : (
                                                                                                    <div className="more-menu-item more-menu-item-disabled">
                                                                                                        <FeatherIcon icon="lock" size="13" />
                                                                                                        사용 중인 템플릿은 삭제할 수 없습니다
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div></div>,
                                                                                        document.body
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* 신규 템플릿 작성 폼 (편집 중인 슬롯이 있을 때만 인라인) */}
                                                {editingSlot && (
                                                    <div className="template-edit-pane">
                                                        <div className="edit-pane-header">
                                                            <FeatherIcon icon="edit-3" size="14" />
                                                            <strong>새 템플릿 작성</strong>
                                                            <span className="edit-pane-hint">슬롯 #{tempSlots.indexOf(editingSlot) + 1}</span>
                                                        </div>
                                                        <FormTextarea
                                                            name="templtContent"
                                                            style={{height: '180px', fontSize: '14px', lineHeight: '1.6'}}
                                                            value={this.boosterSetting[editingSlot] ? this.boosterSetting[editingSlot].templtContent : this.templtContent}
                                                            onChange={event => { this.onChangeTempltContentValue(event, this.boosterSetting, [editingSlot]) }}
                                                        />
                                                        {/* 채널추가 버튼 옵션 — 카카오 규격상 버튼 최상단에 "채널 추가"(AC) 버튼이 함께 등록됨 */}
                                                        <div className="edit-pane-option" style={{margin: '10px 0 2px'}}>
                                                            <FormCheckbox toggle small
                                                                checked={!!(this.boosterSetting[editingSlot] && this.boosterSetting[editingSlot].addChannelButton)}
                                                                onChange={() => {
                                                                    if (!this.boosterSetting[editingSlot]) {
                                                                        this.boosterSetting[editingSlot] = { templtContent: this.templtContent };
                                                                    }
                                                                    this.boosterSetting[editingSlot].addChannelButton = !this.boosterSetting[editingSlot].addChannelButton;
                                                                }}>
                                                                채널추가 버튼 넣기
                                                                <span style={{marginLeft: 6, color: '#9CA3AF', fontSize: '12px'}}>메시지에 카카오 채널 추가 버튼이 함께 노출됩니다</span>
                                                            </FormCheckbox>
                                                        </div>
                                                        <div className="edit-pane-actions">
                                                            <Button size="sm" theme="light"
                                                                    onClick={() => {
                                                                        this.isTempEdit[editingSlot] = false;
                                                                        this.boosterSetting[editingSlot] = null;
                                                                        if (this.selectedTemplateSlot === editingSlot) this.selectedTemplateSlot = null;
                                                                    }}>
                                                                취소
                                                            </Button>
                                                            <Button size="sm" theme="primary"
                                                                    onClick={() => this.setKakaoTemp("genTemp", this.boosterSetting[editingSlot], editingSlot)}>
                                                                <FeatherIcon icon="check" size="12" style={{marginRight: '3px'}} />템플릿 생성 (심사요청)
                                                            </Button>
                                                        </div>
                                                        <div className="edit-pane-tip">
                                                            <FeatherIcon icon="info" size="12" />
                                                            치환 변수: <code>#&#123;name&#125;</code>, <code>#&#123;shop&#125;</code>, <code>#&#123;product&#125;</code>
                                                            ・ 작성 가이드는 <a href="https://kakaobusiness.gitbook.io/main/ad/infotalk/content-guide" target="_blank" rel="noopener noreferrer">여기</a>에서 확인
                                                        </div>
                                                    </div>
                                                )}
                                            </Col>

                                            {/* 우측: 카카오톡 채팅방 스타일 미리보기 */}
                                            <Col lg="5" md="12">
                                                <div className="preview-pane preview-pane-kakao">
                                                    <div className="preview-header">
                                                        <FeatherIcon icon="smartphone" size="14" />
                                                        <strong>카카오톡 미리보기</strong>
                                                        {previewTemp && previewTemp.templtCode && (
                                                            <Badge outline theme="secondary" className="ml-2" style={{fontSize: '11px'}}>
                                                                {previewTemp.templtCode}
                                                            </Badge>
                                                        )}
                                                    </div>
                                                    {(previewTemp && previewTemp.templtContent) || editingSlot ? (
                                                        <div className="kakao-chat-frame"
                                                             key={previewSlot || editingSlot || 'preview'}
                                                             role="img"
                                                             aria-label={`카카오톡 미리보기. ${(previewTemp && previewTemp.templtCode) || '편집 중인 템플릿'}`}>
                                                            {/* 채팅방 헤더 (뒤로가기, 채널명, 메뉴) */}
                                                            <div className="kakao-chat-titlebar" aria-hidden="true">
                                                                <FeatherIcon icon="chevron-left" size="18" />
                                                                <div className="kakao-chat-title">
                                                                    <span className="title-text">{this.store.name || '온리플'}</span>
                                                                </div>
                                                                <FeatherIcon icon="search" size="16" />
                                                                <FeatherIcon icon="menu" size="16" />
                                                            </div>

                                                            {/* 채팅방 본문 */}
                                                            <div className="kakao-chat-body">
                                                                <div className="kakao-chat-date">오늘</div>

                                                                <div className="kakao-chat-msg-row">
                                                                    {/* 프로필 이미지 */}
                                                                    <div className="kakao-chat-avatar">
                                                                        <FeatherIcon icon="message-circle" size="20" />
                                                                    </div>
                                                                    <div className="kakao-chat-bubble-wrap">
                                                                        <div className="kakao-chat-name">{this.store.name || '온리플'}</div>
                                                                        <div className="kakao-chat-bubble-row">
                                                                            <div className="kakao-chat-bubble">
                                                                                <div className="kakao-bubble-tag">알림톡 도착</div>
                                                                                <div className="kakao-bubble-image">
                                                                                    <img src="https://mud-kage.kakao.com/dn/vImIP/btsN3hmvUSH/lJy0kCjc5RKJkB7YDFz04k/img_l.jpg" alt="Review" />
                                                                                </div>
                                                                                <div className="kakao-bubble-text">
                                                                                    <pre>{
                                                                                        editingSlot && this.boosterSetting[editingSlot] && this.boosterSetting[editingSlot].templtContent
                                                                                            ? this.boosterSetting[editingSlot].templtContent
                                                                                            : (previewTemp ? previewTemp.templtContent : '')
                                                                                    }</pre>
                                                                                </div>
                                                                                {/* 채널추가(AC) 버튼 — 편집 중엔 체크 상태, 등록된 템플릿은 버튼 목록으로 판단.
                                                                                    채널추가형(AD) 템플릿은 카카오 고정 안내 문구가 본문 하단에 함께 노출됨 */}
                                                                                {(editingSlot
                                                                                    ? !!(this.boosterSetting[editingSlot] && this.boosterSetting[editingSlot].addChannelButton)
                                                                                    : !!(previewTemp && Array.isArray(previewTemp.buttons) && previewTemp.buttons.some(b => b.linkType === 'AC'))) && (
                                                                                    <React.Fragment>
                                                                                        <div style={{padding: '6px 12px 0', fontSize: '11px', color: '#9CA3AF', lineHeight: 1.4}}>
                                                                                            채널 추가하고 이 채널의 마케팅 메시지 등을 카카오톡으로 받기
                                                                                        </div>
                                                                                        <div className="kakao-bubble-button">
                                                                                            채널 추가
                                                                                        </div>
                                                                                    </React.Fragment>
                                                                                )}
                                                                                <div className="kakao-bubble-button">
                                                                                    리뷰 작성하기
                                                                                </div>
                                                                            </div>
                                                                            <div className="kakao-chat-time">
                                                                                {moment().format('A h:mm').replace('AM', '오전').replace('PM', '오후')}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* 채팅방 입력바 */}
                                                            <div className="kakao-chat-inputbar" aria-hidden="true">
                                                                <FeatherIcon icon="plus" size="18" />
                                                                <div className="kakao-chat-input-placeholder">메시지 입력</div>
                                                                <FeatherIcon icon="smile" size="18" />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="preview-empty">
                                                            <FeatherIcon icon="inbox" size="36" />
                                                            <p>좌측에서 템플릿을 선택하세요</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Collapse>
                            </Card>
                        )}

                        {/* ========== 섹션 3: 발송 설정 (전면 리디자인) ========== */}
                        <Card className="mb-3 redesign-section settings-redesign">
                            <CardHeader className="collapsible-header"
                                        role="button"
                                        tabIndex={0}
                                        aria-expanded={this.expandedSections.settings}
                                        aria-controls="section-settings-body"
                                        onClick={() => this.toggleSection('settings')}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleSection('settings'); } }}>
                                <div className="header-left">
                                    <FeatherIcon icon="sliders" size="16" />
                                    <h5 className="m-0">발송 설정</h5>
                                    <span className="header-desc">메시지 발송 시점과 재발송 정책을 설정합니다</span>
                                    {this.isSettingsDirty && (
                                        <Badge theme="warning" style={{fontSize: '10px', marginLeft: '8px'}}>
                                            저장되지 않음
                                        </Badge>
                                    )}
                                </div>
                                <FeatherIcon icon={this.expandedSections.settings ? 'chevron-up' : 'chevron-down'} size="18" />
                            </CardHeader>
                            <Collapse open={this.expandedSections.settings}>
                                <CardBody className={!isChannelRegistered ? 'disabled' : ''} style={{padding: 0}}>

                                    {/* === 마스터 토글 (상단 큰 배치) === */}
                                    <div className="master-toggle-bar" id="section-settings-body" role="region" aria-label="알림톡 발송 설정">
                                        <div className="master-toggle-info">
                                            <div className="master-toggle-icon">
                                                <FeatherIcon icon="bell" size="22" />
                                            </div>
                                            <div>
                                                <div className="master-toggle-title">알림톡 자동 발송</div>
                                                <div className="master-toggle-desc">
                                                    {!hasActiveTemplate
                                                        ? '사용중인 템플릿이 없어 켤 수 없습니다 — 템플릿 등록 후 이용해 주세요'
                                                        : this.boosterSetting.isSendMsg
                                                            ? '주문 도착 후 자동으로 리뷰 작성 알림톡을 발송합니다'
                                                            : '꺼져 있습니다 — 켜야 하위 설정이 적용됩니다'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="master-toggle-switch">
                                            <FormCheckbox
                                                toggle
                                                disabled={!hasActiveTemplate && !this.boosterSetting.isSendMsg}
                                                checked={!!this.boosterSetting.isSendMsg}
                                                onChange={event => {
                                                    // 사용중 템플릿이 없으면 켤 수 없음 (끄는 것은 허용)
                                                    if (!hasActiveTemplate && !this.boosterSetting.isSendMsg) return;
                                                    this.onChangeChecked(event, this.boosterSetting, ['isSendMsg']);
                                                    this.recomputeSettingsDirty();
                                                }}>
                                                <strong style={{color: this.boosterSetting.isSendMsg ? '#10b981' : '#adb5bd', fontSize: '15px'}}>
                                                    {this.boosterSetting.isSendMsg ? 'ON' : 'OFF'}
                                                </strong>
                                            </FormCheckbox>
                                        </div>
                                    </div>

                                    {/* 사용중 템플릿 없음 — 자동 발송 불가 안내 */}
                                    {isChannelRegistered && !hasActiveTemplate && (
                                        <div style={{
                                            margin: '0 20px 14px', padding: '10px 12px',
                                            background: '#FFFBEB', border: '1px solid #FDE68A',
                                            borderRadius: 6, fontSize: 12.5, color: '#92400E', lineHeight: 1.6,
                                            display: 'flex', alignItems: 'flex-start', gap: 8
                                        }}>
                                            <FeatherIcon icon="alert-triangle" size="13" style={{marginTop: 2, flexShrink: 0}} />
                                            <div>
                                                사용중인 템플릿이 없어 <b>알림톡 자동 발송</b>을 켤 수 없습니다.
                                                상단 <b>템플릿 관리</b>에서 템플릿을 등록하고, 카카오 승인 완료 후 <b>사용하기</b>로 지정해 주세요.
                                            </div>
                                        </div>
                                    )}

                                    {/* === Split View: 좌측 설정 + 우측 미리보기 === */}
                                    <div className={`settings-split ${!this.boosterSetting.isSendMsg ? 'is-dimmed' : ''}`}>
                                        <div className="settings-split-left">

                                            {/* Card 1: 첫 발송 시점 */}
                                            <div className={`setting-card ${this.isFieldDirty('firstSend') ? 'is-dirty' : ''}`}>
                                                <div className="setting-card-header">
                                                    <FeatherIcon icon="send" size="15" />
                                                    <strong>첫 메시지 발송 시점</strong>
                                                    <span className="setting-card-help"
                                                          title="상품이 고객에게 도착한 시점부터 며칠 후에 첫 알림톡을 보낼지 설정합니다.">
                                                        <FeatherIcon icon="help-circle" size="13" />
                                                    </span>
                                                    {this.isFieldDirty('firstSend') && <span className="dirty-dot" title="변경됨" aria-label="변경됨" />}
                                                </div>
                                                <div className="chip-group" role="radiogroup" aria-label="첫 메시지 발송 시점 선택">
                                                    {this.firstSendOptions.map((option) => (
                                                        <button key={option.value} type="button"
                                                                role="radio"
                                                                aria-checked={this.boosterSetting.firstSend === option.value}
                                                                className={`chip ${this.boosterSetting.firstSend === option.value ? 'chip-active' : ''}`}
                                                                onClick={() => this.updateSettingField('firstSend', option.value, 'int')}>
                                                            {option.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Card 2: 발송 시간대 */}
                                            <div className={`setting-card ${(this.isFieldDirty('sendStartTime') || this.isFieldDirty('sendEndTime')) ? 'is-dirty' : ''}`}>
                                                <div className="setting-card-header">
                                                    <FeatherIcon icon="clock" size="15" />
                                                    <strong>발송 시간대</strong>
                                                    <span className="setting-card-help"
                                                          title="알림톡이 발송될 수 있는 하루 중 시간대를 설정합니다. 야간 발송을 방지합니다.">
                                                        <FeatherIcon icon="help-circle" size="13" />
                                                    </span>
                                                    {(this.isFieldDirty('sendStartTime') || this.isFieldDirty('sendEndTime')) && <span className="dirty-dot" title="변경됨" aria-label="변경됨" />}
                                                </div>
                                                <div className="time-range-picker">
                                                    <div className="time-display">
                                                        <div className="time-display-cell time-display-cell--start">
                                                            <span className="time-label"><span className="time-dot time-dot--start" aria-hidden="true" />시작</span>
                                                            <strong className="time-value">{String(this.sendStartHour).padStart(2, '0')}:00</strong>
                                                            <span className="time-suffix">{this.formatHour(this.sendStartHour)}</span>
                                                        </div>
                                                        <div className="time-arrow">
                                                            <FeatherIcon icon="arrow-right" size="18" />
                                                        </div>
                                                        <div className="time-display-cell time-display-cell--end">
                                                            <span className="time-label"><span className="time-dot time-dot--end" aria-hidden="true" />종료</span>
                                                            <strong className="time-value">{String(this.sendEndHour).padStart(2, '0')}:00</strong>
                                                            <span className="time-suffix">{this.formatHour(this.sendEndHour)}</span>
                                                        </div>
                                                    </div>

                                                    {/* 알림톡 경유 리뷰 작성 시간 분포 — 발송 시간대 설정 참고 (아래 타임라인과 동일 그리드로 수직 정렬) */}
                                                    {this.alimHourStats && this.alimHourStats.total > 0 && (() => {
                                                        const stats = this.alimHourStats;
                                                        const maxCount = Math.max(...stats.hours);
                                                        const peakHour = stats.hours.indexOf(maxCount);
                                                        return (
                                                            <div className="alim-hour-stats">
                                                                <div className="alim-hour-stats__head">
                                                                    <span className="alim-hour-stats__title">
                                                                        <FeatherIcon icon="bar-chart-2" size="12" />
                                                                        알림톡 리뷰 작성 시간 분포 분석 그래프
                                                                    </span>
                                                                    <span className="alim-hour-stats__meta">
                                                                        전체 스토어 · 최근 {stats.periodDays}일 · {stats.total.toLocaleString()}건 · 피크 <strong>{String(peakHour).padStart(2, '0')}시</strong>
                                                                    </span>
                                                                </div>
                                                                <div className="alim-hour-stats__bars" role="img"
                                                                     aria-label={`알림톡 리뷰 작성 시간 분포 (온리플 전체 스토어 기준). 최근 ${stats.periodDays}일 ${stats.total}건, 가장 많이 작성된 시간 ${peakHour}시`}>
                                                                    {stats.hours.map((c, h) => {
                                                                        const inRange = h >= this.sendStartHour && h < this.sendEndHour;
                                                                        return (
                                                                            <div key={h} className="alim-hour-bar"
                                                                                 title={`${String(h).padStart(2, '0')}:00 — ${c}건${h === peakHour && c > 0 ? ' (피크)' : ''}`}>
                                                                                <div className={`alim-hour-bar__fill${inRange ? ' in-range' : ''}${h === peakHour && c > 0 ? ' is-peak' : ''}`}
                                                                                     style={{height: c > 0 ? `${Math.max(8, Math.round((c / maxCount) * 100))}%` : 0}} />
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                                <div className="alim-hour-stats__hint">
                                                                    온리플 전체 스토어 기준, 고객이 알림톡으로 리뷰를 많이 작성한 시간대입니다 — 발송 시간대 설정에 참고하세요
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}

                                                    {/* 인터랙티브 타임라인: 시간 눈금 위의 시작/종료 핸들을 드래그해 조절 */}
                                                    <div className={`time-timeline time-timeline--interactive ${this.draggingHandle ? 'is-dragging' : ''}`}
                                                         ref={this.setTimelineRef}
                                                         onMouseDown={this.onTimelineBarDown}
                                                         onTouchStart={this.onTimelineBarDown}>
                                                        {Array.from({length: 24}, (_, h) => {
                                                            const isActive = h >= this.sendStartHour && h < this.sendEndHour;
                                                            return <div key={h}
                                                                        className={`timeline-tick ${isActive ? 'active' : ''}`}
                                                                        title={`${String(h).padStart(2, '0')}:00`}/>;
                                                        })}
                                                        <button type="button"
                                                                className={`timeline-handle timeline-handle--start ${this.draggingHandle === 'start' ? 'is-dragging' : ''}`}
                                                                style={{left: `${(this.sendStartHour / 24) * 100}%`}}
                                                                onMouseDown={(e) => this.startTimelineDrag('start', e)}
                                                                onTouchStart={(e) => this.startTimelineDrag('start', e)}
                                                                onKeyDown={(e) => this.onTimelineHandleKeyDown('start', e)}
                                                                role="slider"
                                                                aria-label="발송 시작 시간 (드래그 또는 방향키로 조절)"
                                                                aria-valuemin={0}
                                                                aria-valuemax={this.sendEndHour - 1}
                                                                aria-valuenow={this.sendStartHour}
                                                                aria-valuetext={this.formatHour(this.sendStartHour)}>
                                                            <span className="handle-bubble">시작 {String(this.sendStartHour).padStart(2, '0')}:00</span>
                                                        </button>
                                                        <button type="button"
                                                                className={`timeline-handle timeline-handle--end ${this.draggingHandle === 'end' ? 'is-dragging' : ''}`}
                                                                style={{left: `${(this.sendEndHour / 24) * 100}%`}}
                                                                onMouseDown={(e) => this.startTimelineDrag('end', e)}
                                                                onTouchStart={(e) => this.startTimelineDrag('end', e)}
                                                                onKeyDown={(e) => this.onTimelineHandleKeyDown('end', e)}
                                                                role="slider"
                                                                aria-label="발송 종료 시간 (드래그 또는 방향키로 조절)"
                                                                aria-valuemin={this.sendStartHour + 1}
                                                                aria-valuemax={23}
                                                                aria-valuenow={this.sendEndHour}
                                                                aria-valuetext={this.formatHour(this.sendEndHour)}>
                                                            <span className="handle-bubble">종료 {String(this.sendEndHour).padStart(2, '0')}:00</span>
                                                        </button>
                                                    </div>
                                                    <div className="time-timeline-labels">
                                                        <span>0시</span><span>6시</span><span>12시</span><span>18시</span><span>24시</span>
                                                    </div>
                                                    <div className="time-timeline-hint">
                                                        <span className="hint-chip hint-chip--start">● 시작</span>
                                                        <span className="hint-chip hint-chip--end">● 종료</span>
                                                        <span>핸들을 드래그해 발송 시간대를 조절하세요</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Card 3: 재발송 주기 */}
                                            <div className={`setting-card ${this.isFieldDirty('sendInterval') ? 'is-dirty' : ''}`}>
                                                <div className="setting-card-header">
                                                    <FeatherIcon icon="repeat" size="15" />
                                                    <strong>재발송 주기</strong>
                                                    <span className="setting-card-help"
                                                          title="리뷰를 작성하지 않은 고객에게 며칠 간격으로 다시 알림톡을 보낼지 설정합니다.">
                                                        <FeatherIcon icon="help-circle" size="13" />
                                                    </span>
                                                    {this.isFieldDirty('sendInterval') && <span className="dirty-dot" title="변경됨" aria-label="변경됨" />}
                                                </div>
                                                <div className="chip-group" role="radiogroup" aria-label="재발송 주기 선택">
                                                    {this.sendIntervalOptions.map((option) => (
                                                        <button key={option.value} type="button"
                                                                role="radio"
                                                                aria-checked={this.boosterSetting.sendInterval === option.value}
                                                                className={`chip ${this.boosterSetting.sendInterval === option.value ? 'chip-active' : ''}`}
                                                                onClick={() => this.updateSettingField('sendInterval', option.value, 'int')}>
                                                            {option.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Card 4: 재발송 횟수 */}
                                            <div className={`setting-card ${this.isFieldDirty('sendCount') ? 'is-dirty' : ''}`}>
                                                <div className="setting-card-header">
                                                    <FeatherIcon icon="hash" size="15" />
                                                    <strong>재발송 횟수</strong>
                                                    <span className="setting-card-help"
                                                          title="최대 몇 번까지 재발송을 시도할지 설정합니다. 0회를 선택하면 첫 발송만 진행됩니다.">
                                                        <FeatherIcon icon="help-circle" size="13" />
                                                    </span>
                                                    {this.isFieldDirty('sendCount') && <span className="dirty-dot" title="변경됨" aria-label="변경됨" />}
                                                </div>
                                                <div className="chip-group" role="radiogroup" aria-label="재발송 횟수 선택">
                                                    {this.sendCountOptions.map((option) => (
                                                        <button key={option.value} type="button"
                                                                role="radio"
                                                                aria-checked={this.boosterSetting.sendCount === option.value}
                                                                className={`chip ${this.boosterSetting.sendCount === option.value ? 'chip-active' : ''} ${option.value === 0 ? 'chip-warn' : ''}`}
                                                                onClick={() => this.updateSettingField('sendCount', option.value, 'int')}>
                                                            {option.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* === 우측 Live 미리보기 === */}
                                        <div className="settings-split-right">
                                            <div className="settings-summary-card">
                                                <div className="summary-card-header">
                                                    <FeatherIcon icon="eye" size="14" />
                                                    <strong>실시간 요약</strong>
                                                </div>
                                                <div className="summary-list">
                                                    <div className="summary-row">
                                                        <FeatherIcon icon="send" size="14" />
                                                        <div className="summary-text">
                                                            <span className="summary-key">첫 발송</span>
                                                            <strong className="summary-val">
                                                                {this.boosterSetting.firstSend === 0
                                                                    ? '도착 당일 즉시'
                                                                    : `도착 ${this.boosterSetting.firstSend}일 후`}
                                                            </strong>
                                                        </div>
                                                    </div>
                                                    <div className="summary-row">
                                                        <FeatherIcon icon="clock" size="14" />
                                                        <div className="summary-text">
                                                            <span className="summary-key">발송 시간대</span>
                                                            <strong className="summary-val">
                                                                {this.formatHour(this.sendStartHour)} ~ {this.formatHour(this.sendEndHour)}
                                                            </strong>
                                                        </div>
                                                    </div>
                                                    <div className="summary-row">
                                                        <FeatherIcon icon="repeat" size="14" />
                                                        <div className="summary-text">
                                                            <span className="summary-key">재발송 주기</span>
                                                            <strong className="summary-val">{this.boosterSetting.sendInterval}일마다</strong>
                                                        </div>
                                                    </div>
                                                    <div className="summary-row">
                                                        <FeatherIcon icon="hash" size="14" />
                                                        <div className="summary-text">
                                                            <span className="summary-key">재발송 횟수</span>
                                                            <strong className="summary-val">
                                                                {this.boosterSetting.sendCount === 0
                                                                    ? '재발송 안 함'
                                                                    : `최대 ${this.boosterSetting.sendCount}회`}
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 시각적 사이클 다이어그램 */}
                                                <div className="cycle-viz">
                                                    <div className="cycle-viz-title">예상 발송 일정</div>
                                                    <div className="cycle-viz-line">
                                                        <div className="cycle-step">
                                                            <div className="cycle-dot arrived">D</div>
                                                            <div className="cycle-label">
                                                                <span className="cycle-label-tag tag-arrived">도착</span>
                                                                <span className="cycle-label-day">기준일</span>
                                                            </div>
                                                        </div>
                                                        <div className="cycle-arrow"/>
                                                        <div className="cycle-step">
                                                            <div className="cycle-dot active">1</div>
                                                            <div className="cycle-label">
                                                                <span className="cycle-label-tag tag-first">첫 메시지</span>
                                                                <span className="cycle-label-day">+{this.boosterSetting.firstSend || 0}일</span>
                                                            </div>
                                                        </div>
                                                        {this.boosterSetting.sendCount > 0 && Array.from({length: Math.min(3, this.boosterSetting.sendCount)}, (_, i) => (
                                                            <React.Fragment key={i}>
                                                                <div className="cycle-arrow"/>
                                                                <div className="cycle-step">
                                                                    <div className="cycle-dot retry">{i + 2}</div>
                                                                    <div className="cycle-label">
                                                                        <span className="cycle-label-tag tag-retry">재발송 {i + 1}회</span>
                                                                        <span className="cycle-label-day">+{(this.boosterSetting.firstSend || 0) + (this.boosterSetting.sendInterval * (i + 1))}일</span>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        ))}
                                                        {this.boosterSetting.sendCount > 3 && (
                                                            <>
                                                                <div className="cycle-arrow"/>
                                                                <div className="cycle-step">
                                                                    <div className="cycle-dot more">···</div>
                                                                    <div className="cycle-label">
                                                                        <span className="cycle-label-tag tag-more">재발송</span>
                                                                        <span className="cycle-label-day">{this.boosterSetting.sendCount - 3}회 더</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* 사용중 템플릿 카카오톡 미리보기 — 실제 발송될 메시지 확인용 */}
                                                <div className="summary-kakao-preview" style={{marginTop: 18}}>
                                                    <div style={{
                                                        fontSize: 11, color: '#94A3B8', fontWeight: 600,
                                                        textTransform: 'uppercase', letterSpacing: '0.5px',
                                                        marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6
                                                    }}>
                                                        카카오톡 미리보기
                                                        {hasActiveTemplate && (
                                                            <Badge outline theme="secondary" style={{fontSize: '10px'}}>
                                                                {activeTemp.templtCode} · 사용중
                                                            </Badge>
                                                        )}
                                                    </div>
                                                    {hasActiveTemplate && activeTemp.templtContent ? (
                                                        <div className="preview-pane-kakao" style={{borderRadius: 10, padding: 12}}>
                                                            <div className="kakao-chat-frame"
                                                                 role="img"
                                                                 aria-label={`사용중 템플릿 ${activeTemp.templtCode} 카카오톡 미리보기`}>
                                                                {/* 채팅방 헤더 */}
                                                                <div className="kakao-chat-titlebar" aria-hidden="true">
                                                                    <FeatherIcon icon="chevron-left" size="18" />
                                                                    <div className="kakao-chat-title">
                                                                        <span className="title-text">{this.store.name || '온리플'}</span>
                                                                    </div>
                                                                    <FeatherIcon icon="search" size="16" />
                                                                    <FeatherIcon icon="menu" size="16" />
                                                                </div>
                                                                {/* 채팅방 본문 */}
                                                                <div className="kakao-chat-body">
                                                                    <div className="kakao-chat-date">오늘</div>
                                                                    <div className="kakao-chat-msg-row">
                                                                        <div className="kakao-chat-avatar">
                                                                            <FeatherIcon icon="message-circle" size="20" />
                                                                        </div>
                                                                        <div className="kakao-chat-bubble-wrap">
                                                                            <div className="kakao-chat-name">{this.store.name || '온리플'}</div>
                                                                            <div className="kakao-chat-bubble-row">
                                                                                <div className="kakao-chat-bubble">
                                                                                    <div className="kakao-bubble-tag">알림톡 도착</div>
                                                                                    <div className="kakao-bubble-image">
                                                                                        <img src="https://mud-kage.kakao.com/dn/vImIP/btsN3hmvUSH/lJy0kCjc5RKJkB7YDFz04k/img_l.jpg" alt="Review" />
                                                                                    </div>
                                                                                    <div className="kakao-bubble-text">
                                                                                        <pre>{activeTemp.templtContent}</pre>
                                                                                    </div>
                                                                                    {Array.isArray(activeTemp.buttons) && activeTemp.buttons.some(b => b.linkType === 'AC') && (
                                                                                        <React.Fragment>
                                                                                            <div style={{padding: '6px 12px 0', fontSize: '11px', color: '#9CA3AF', lineHeight: 1.4}}>
                                                                                                채널 추가하고 이 채널의 마케팅 메시지 등을 카카오톡으로 받기
                                                                                            </div>
                                                                                            <div className="kakao-bubble-button">채널 추가</div>
                                                                                        </React.Fragment>
                                                                                    )}
                                                                                    <div className="kakao-bubble-button">리뷰 작성하기</div>
                                                                                </div>
                                                                                <div className="kakao-chat-time">
                                                                                    {moment().format('A h:mm').replace('AM', '오전').replace('PM', '오후')}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* 채팅방 입력바 */}
                                                                <div className="kakao-chat-inputbar" aria-hidden="true">
                                                                    <FeatherIcon icon="plus" size="18" />
                                                                    <div className="kakao-chat-input-placeholder">메시지 입력</div>
                                                                    <FeatherIcon icon="smile" size="18" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{
                                                            padding: '18px 12px', textAlign: 'center',
                                                            background: '#F8FAFC', border: '1px dashed #CBD5E1',
                                                            borderRadius: 10, color: '#94A3B8', fontSize: 12.5, lineHeight: 1.6
                                                        }}>
                                                            사용중인 템플릿이 없습니다.<br/>상단 <b>템플릿 관리</b>에서 사용할 템플릿을 지정해 주세요.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 저장/되돌리기는 페이지 하단의 wbp-sticky-save 통합 바에서 처리 (위젯 설정과 동일 패턴) */}
                                </CardBody>
                            </Collapse>
                        </Card>

                        {/* ========== 섹션 4: 카카오 채널 등록 (미연동 상태일 때만) ========== */}
                        {!isChannelRegistered && (
                            <Card className="mb-3 redesign-section">
                                <CardHeader className="collapsible-header"
                                            role="button"
                                            tabIndex={0}
                                            aria-expanded={this.expandedSections.channel}
                                            aria-controls="section-channel-body"
                                            onClick={() => this.toggleSection('channel')}
                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleSection('channel'); } }}>
                                    <div className="header-left">
                                        <FeatherIcon icon="link" size="16" />
                                        <h5 className="m-0">카카오 채널 등록</h5>
                                        <span className="header-desc">알림톡 발송을 위해 카카오 비즈니스 채널을 연동하세요</span>
                                    </div>
                                    <FeatherIcon icon={this.expandedSections.channel ? 'chevron-up' : 'chevron-down'} size="18" />
                                </CardHeader>
                                <Collapse open={this.expandedSections.channel}>
                                    <CardBody>
                                        <div className="d-flex align-items-center mb-3">
                                            <span className="mr-3" style={{minWidth: '180px'}}>관리자 연락처</span>
                                            <FormInput
                                                placeholder="관리자 연락처"
                                                name="tel"
                                                value={this.teamUser.tel}
                                                onChange={this.onInputChange}
                                                className="mr-2"
                                                style={{ maxWidth: '200px' }}
                                                readOnly
                                            />
                                        </div>
                                        <div className="d-flex align-items-center mb-3">
                                            <span className="mr-3" style={{minWidth: '180px'}}>카카오 채널 검색용 아이디</span>
                                            <FormInput
                                                placeholder="채널 아이디 (예: onreple)"
                                                name="kakaoPlusid"
                                                value={this.boosterSetting.kakaoPlusid || ''}
                                                onChange={this.onInputChange}
                                                className="mr-2"
                                                style={{ maxWidth: '200px' }}
                                            />
                                            {!this.regedPlusId ? (
                                                <Button theme="primary" onClick={event => { this.onChangeStep(2) }}>등록하기</Button>
                                            ) : (
                                                <Button theme="primary">변경하기</Button>
                                            )}
                                        </div>
                                        {this.authStep > 1 ? (
                                            <div className="d-flex align-items-center mb-3 inline-selector">
                                                <span className="mr-3" style={{minWidth: '180px'}}>카테고리</span>
                                                <FormSelect
                                                    value={this.category[0]}
                                                    name="firstCate"
                                                    onChange={event => { this.onChangeSelect(event) }}>
                                                    <option value="0">-선택해 주세요-</option>
                                                    {this.categoryOptions.firstCate.map((option) => (
                                                        <option key={option.code} value={option.code}>{option.name}</option>
                                                    ))}
                                                </FormSelect>
                                                {this.categoryOptions.secondCate && this.categoryOptions.secondCate.length > -1 ? (
                                                    <FormSelect
                                                        value={this.category[1]}
                                                        name="secondCate"
                                                        onChange={event => { this.onChangeSelect(event) }}>
                                                        <option value="0">-선택해 주세요-</option>
                                                        {this.categoryOptions.secondCate.map((option) => (
                                                            <option key={option.code} value={option.code}>{option.name}</option>
                                                        ))}
                                                    </FormSelect>
                                                ) : null}
                                                {this.categoryOptions.thirdCate && this.categoryOptions.thirdCate.length > -1 ? (
                                                    <FormSelect
                                                        value={this.category[2]}
                                                        name="thirdCate"
                                                        onChange={event => { this.onChangeSelect(event) }}>
                                                        <option value="0">-선택해 주세요-</option>
                                                        {this.categoryOptions.thirdCate.map((option) => (
                                                            <option key={option.code} value={option.code}>{option.name}</option>
                                                        ))}
                                                    </FormSelect>
                                                ) : null}
                                            </div>
                                        ) : null}
                                        {this.authStep > 1 && this.boosterSetting.categorycode ? (
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="mr-3" style={{minWidth: '180px'}}>관리자 휴대폰번호</span>
                                                <FormInput
                                                    name="phonenumber"
                                                    placeholder="01011111111"
                                                    value={this.boosterSetting.phonenumber}
                                                    onChange={this.onInputChange}
                                                    className="mr-2"
                                                    style={{ maxWidth: '200px' }}
                                                />
                                                <Button theme="primary" onClick={event => { this.onChangeStep(3) }}>인증번호 받기</Button>
                                                {this.authStep > 3 ? (
                                                    <>
                                                        <span className="ml-20 mr-3">인증번호</span>
                                                        <FormInput
                                                            name="authnum"
                                                            placeholder="인증번호"
                                                            value={this.boosterSetting.authnum}
                                                            onChange={this.onInputChange}
                                                            className="mr-2"
                                                            style={{ maxWidth: '200px' }}
                                                        />
                                                        <Button theme="primary" onClick={event => { this.onChangeStep(5) }}>등록하기</Button>
                                                    </>
                                                ) : null}
                                            </div>
                                        ) : null}

                                        <div className="info-guide-box">
                                            <h6><FeatherIcon icon="info" size="14" style={{marginRight: '4px'}} />안내</h6>
                                            <ul>
                                                <li>카카오채널 정보의 검색용 아이디를 입력해 주세요. (<a href={"https://center-pf.kakao.com/_Tsxopxb/profile/settings"} target={"_blank"}>확인하기</a>)</li>
                                                <li>보유한 카카오채널 계정이 없을 경우 <a href={"https://center-pf.kakao.com"} target={"_blank"}>카카오 비즈니스 센터</a>에서 등록 후 진행 가능합니다.</li>
                                                <li>카카오채널 관리자로 등록된 휴대폰 번호를 입력해 주세요.</li>
                                                <li>인증된 휴대폰 번호는 온리플 관리자 전화번호와 함께 수정되며, 인증 후 변경이 불가합니다.</li>
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Collapse>
                            </Card>
                        )}


                        <div className="info-guide-box" style={{marginBottom: '20px'}}>
                            <h6><FeatherIcon icon="book-open" size="14" style={{marginRight: '4px'}} />카카오 알림톡 안내</h6>
                            <ul>
                                <li><a href="https://kakaobusiness.gitbook.io/main/ad/infotalk/content-guide" target="_blank" rel="noopener noreferrer">카카오 알림톡 템플릿 작성 가이드 바로가기</a></li>
                                <li>템플릿 심사는 카카오에서 진행하며, 영업일 기준 1~3일 정도 소요됩니다.</li>
                            </ul>
                        </div>

                        {/* === Sticky 저장 바 (위젯 설정과 동일한 wbp-sticky-save 패턴, dirty 있을 때만 노출) === */}
                        {this.isSettingsDirty && (
                            <div className="wbp-sticky-save wbp-sticky-save--top" role="status" aria-live="polite">
                                <div className="wbp-sticky-save__msg">
                                    <FeatherIcon icon="alert-circle" size="16" />
                                    {dirtySettingLabels.length > 0 ? (
                                        <span><strong>{dirtySettingLabels.length}개 설정</strong>에 저장되지 않은 변경사항이 있습니다.</span>
                                    ) : (
                                        <span>저장되지 않은 변경사항이 있습니다.</span>
                                    )}
                                    {dirtySettingLabels.length > 0 && (
                                        <span className="wbp-sticky-save__tags">
                                            {dirtySettingLabels.map(label => (
                                                <span key={label} className="wbp-sticky-save__tag">{label}</span>
                                            ))}
                                        </span>
                                    )}
                                </div>
                                <div className="wbp-sticky-save__actions">
                                    <Button theme="light" size="sm"
                                            onClick={() => this.revertSettings()}
                                            aria-label="변경사항 취소하고 이전 상태로 되돌리기">
                                        되돌리기
                                    </Button>
                                    <Button theme="primary" size="sm"
                                            disabled={!isChannelRegistered}
                                            onClick={() => this.saveSettingsAndSnapshot()}
                                            aria-label="발송 설정 변경사항 저장">
                                        변경사항 저장
                                    </Button>
                                </div>
                            </div>
                        )}

                    </div>
                    ) :
                    null
                }


                <Modal size="lg" className='modal-text' open={this.modals.isTempComment} toggle={() => this.modals.isTempComment = false} centered={true}>
                    <ModalHeader toggle={() => this.modals.isTempComment = false}>템플릿 처리 내용 보기</ModalHeader>
                    <ModalBody className="history-window-popup">
                        <div className="history-popup-contents">
                            <div className="ws-pre-wrap">{this.modals.data ? this.modals.data.commentContent : ""}</div>


                            <div className="text-center mt-2">
                                {/*<Button onClick={event => this.updateReview(this.modals.data)} >리뷰작성</Button>*/}
                                <Button className="ml-2" theme="light" onClick={event => this.modals.isStoreDetail = false}>닫기</Button>
                            </div>
                        </div>

                    </ModalBody>
                </Modal>

                <Modal size="md" className='modal-text kakao-msg-redesign' open={this.modals.isUseChange} toggle={() => this.modals.isUseChange = false} centered={true}>
                    <ModalHeader toggle={() => this.modals.isUseChange = false}>사용 템플릿 변경</ModalHeader>
                    <ModalBody>
                        <div style={{padding: '8px'}}>
                            <div style={{textAlign: 'center', marginBottom: '24px'}}>
                                <div style={{
                                    width: '64px', height: '64px',
                                    margin: '0 auto 16px',
                                    background: 'linear-gradient(135deg, #4A6CF7 0%, #3a5be0 100%)',
                                    borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    boxShadow: '0 4px 12px rgba(74, 108, 247, 0.3)'
                                }}>
                                    <FeatherIcon icon="check" size="32" color="#fff" />
                                </div>
                                <h5 style={{marginBottom: '8px', fontWeight: 700, fontSize: '20px', color: '#1E293B'}}>이 템플릿을 사용하시겠습니까?</h5>
                                <p style={{color: '#94A3B8', fontSize: '14px', marginBottom: '0'}}>
                                    현재 사용 중인 템플릿이 변경되며,<br/>
                                    이후 발송되는 알림톡에 즉시 적용됩니다.
                                </p>
                            </div>
                            {this.useChangeTarget && this.useChangeTarget.temp && (
                                <div style={{
                                    background: '#F8FAFC',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '12px',
                                    padding: '16px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{fontSize: '12px', color: '#94A3B8', marginBottom: '4px', fontWeight: 600}}>
                                        대상 템플릿
                                    </div>
                                    <div style={{fontSize: '14px', color: '#1E293B', fontWeight: 700}}>
                                        {this.useChangeTarget.temp.templtCode}
                                    </div>
                                </div>
                            )}
                            <div className="text-center" style={{marginTop: '20px'}}>
                                <Button theme="light" onClick={() => this.modals.isUseChange = false}>
                                    취소
                                </Button>
                                <Button className="ml-2" theme="primary" onClick={() => this.confirmUseChange()}>
                                    <FeatherIcon icon="check" size="14" style={{marginRight: '4px'}} />
                                    사용하기
                                </Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal size="md" className='modal-text' open={this.modals.isTestSend} toggle={() => this.modals.isTestSend = false} centered={true}>
                    <ModalHeader toggle={() => this.modals.isTestSend = false}>테스트 알림톡 발송</ModalHeader>
                    <ModalBody>
                        <div style={{padding: '10px'}}>
                            <p style={{marginBottom: '16px', color: '#666', fontSize: '13px'}}>
                                테스트 알림톡을 발송합니다. 수신할 전화번호를 입력해 주세요.<br/>
                                상품을 선택하면 고객이 받은 알림톡에서 <b>실제 리뷰 작성 화면까지</b> 그대로 체험할 수 있습니다.<br/>
                                <span style={{color: '#e74c3c'}}>* 테스트 발송 시 보유 알림톡 1건이 차감됩니다.</span>
                            </p>
                            <FormGroup>
                                <label>템플릿 코드</label>
                                <FormInput
                                    value={this.testSend.templtCode}
                                    readOnly
                                />
                            </FormGroup>

                            {/* 작성자 이름 — 알림톡 인사말(#{'{'}name{'}'})과 리뷰 작성자 이름으로 사용 */}
                            <FormGroup>
                                <label>작성자 이름</label>
                                <FormInput
                                    placeholder="예: 홍길동"
                                    value={this.testSend.writerName}
                                    onChange={e => this.testSend.writerName = e.target.value}
                                />
                                <span style={{fontSize: 11, color: '#9CA3AF'}}>
                                    입력한 이름이 알림톡 인사말과 리뷰 작성자 이름으로 사용됩니다.
                                </span>
                            </FormGroup>

                            {/* 테스트 상품 — 선택 시 고객이 실제 상품 정보로 '작성'까지 체험 */}
                            <FormGroup>
                                <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
                                    테스트 상품
                                    <span style={{fontSize: 11, fontWeight: 400, color: '#9CA3AF'}}>
                                        (선택하면 고객이 이 상품으로 리뷰 작성 화면까지 체험합니다)
                                    </span>
                                </label>

                                {this.testSend.platformProductId ? (
                                    // 선택된 상품 카드
                                    <div style={{
                                        display: 'flex', alignItems: 'center', gap: 10,
                                        padding: 10, border: '1px solid #C7D2FE', background: '#EEF2FF', borderRadius: 8
                                    }}>
                                        {this.testSend.productImage
                                            ? <img src={this.testSend.productImage} alt="" style={{width: 44, height: 44, objectFit: 'cover', borderRadius: 6, flex: '0 0 auto', background: '#fff'}}/>
                                            : <div style={{width: 44, height: 44, borderRadius: 6, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto'}}><FeatherIcon icon="image" size="18" style={{color: '#C7D2FE'}}/></div>}
                                        <div style={{flex: 1, minWidth: 0}}>
                                            <div style={{fontSize: 13, fontWeight: 600, color: '#3730A3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{this.testSend.productName}</div>
                                            <div style={{fontSize: 11, color: '#6366F1'}}>상품번호 {this.testSend.platformProductId}</div>
                                        </div>
                                        <Button size="sm" theme="white" onClick={() => this.toggleProductSearch()}>변경</Button>
                                        <Button size="sm" theme="light" onClick={() => this.clearTestProduct()}>제거</Button>
                                    </div>
                                ) : (
                                    <Button theme="white" onClick={() => this.toggleProductSearch()} style={{width: '100%', border: '1px dashed #C7D2FE', color: '#4A6CF7'}}>
                                        <FeatherIcon icon="plus" size="14" style={{marginRight: 4}}/> 상품 선택 (선택 안 하면 '테스트 상품'으로 발송)
                                    </Button>
                                )}

                                {/* 상품 검색 패널 */}
                                {this.productSearch.isOpen && (
                                    <div style={{marginTop: 8, border: '1px solid #E5E7EB', borderRadius: 8, padding: 10, background: '#FAFAFB'}}>
                                        <div style={{display: 'flex', gap: 6}}>
                                            <FormInput
                                                placeholder="상품명으로 검색"
                                                value={this.productSearch.keyword}
                                                onChange={e => this.productSearch.keyword = e.target.value}
                                                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.searchTestProduct(1); } }}
                                            />
                                            <Button theme="primary" onClick={() => this.searchTestProduct(1)} style={{flex: '0 0 auto'}}>
                                                <FeatherIcon icon="search" size="14"/>
                                            </Button>
                                        </div>

                                        <div style={{marginTop: 8, maxHeight: 240, overflowY: 'auto'}}>
                                            {this.productSearch.isSearching ? (
                                                <div style={{textAlign: 'center', color: '#9CA3AF', fontSize: 12, padding: '20px 0'}}>검색 중…</div>
                                            ) : this.productSearch.results.length === 0 ? (
                                                <div style={{textAlign: 'center', color: '#9CA3AF', fontSize: 12, padding: '20px 0'}}>검색 결과가 없습니다.</div>
                                            ) : (
                                                this.productSearch.results.map((p, idx) => {
                                                    const img = (p.images && (p.images.s_2 || p.images.s_1 || p.images.t_2)) || p.image || '';
                                                    return (
                                                        <div key={p._id || p.platformProductId || idx}
                                                             style={{display: 'flex', alignItems: 'center', gap: 8, padding: '6px 4px', borderBottom: '1px solid #F0F0F2'}}>
                                                            {img
                                                                ? <img src={img} alt="" style={{width: 36, height: 36, objectFit: 'cover', borderRadius: 4, flex: '0 0 auto', background: '#fff'}}/>
                                                                : <div style={{width: 36, height: 36, borderRadius: 4, background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto'}}><FeatherIcon icon="image" size="14" style={{color: '#D1D5DB'}}/></div>}
                                                            <div style={{flex: 1, minWidth: 0}}>
                                                                <div style={{fontSize: 12.5, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{p.productName}</div>
                                                                <div style={{fontSize: 11, color: '#9CA3AF'}}>번호 {p.platformProductId}</div>
                                                            </div>
                                                            <Button size="sm" theme="primary" onClick={() => this.pickTestProduct(p)} style={{flex: '0 0 auto'}}>선택</Button>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>

                                        {this.productSearch.totalPages > 1 && (
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, marginTop: 8}}>
                                                <Button size="sm" theme="light" disabled={this.productSearch.page <= 1} onClick={() => this.goTestProductPage(this.productSearch.page - 1)}>이전</Button>
                                                <span style={{fontSize: 12, color: '#6B7280'}}>{this.productSearch.page} / {this.productSearch.totalPages}</span>
                                                <Button size="sm" theme="light" disabled={this.productSearch.page >= this.productSearch.totalPages} onClick={() => this.goTestProductPage(this.productSearch.page + 1)}>다음</Button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </FormGroup>

                            <FormGroup>
                                <label>수신 전화번호</label>
                                <FormInput
                                    placeholder="01012345678"
                                    value={this.testSend.phoneNumber}
                                    onChange={e => this.testSend.phoneNumber = e.target.value}
                                />
                            </FormGroup>
                            <div className="text-center" style={{marginTop: '20px'}}>
                                <Button theme="success" onClick={() => this.sendTestKakao()}>
                                    <FeatherIcon icon="send" size="14" style={{marginRight: '4px'}} />발송하기
                                </Button>
                                <Button className="ml-2" theme="light" onClick={() => this.modals.isTestSend = false}>취소</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>


                <ModalLoading isLoading={this.isLoading} />
            </div>
        );
    }
}

export default KakaoMsgSetting;